<template>
  <div class="a-download-image-button">
    <GuiButton
      name="download-image"
      class="a-download-image-button__buttons"
      @click="initateDownload"
    >
      <Icon class="a-download-image-button__download-icon" name="download" />
      {{ buttonText }}
    </GuiButton>
    <GuiButton
      class="a-download-image-button__buttons"
      :name="toggleAriaLabel"
      :aria-label="toggleAriaLabel"
    >
      <Icon class="a-download-image-button__expand-icon" :name="iconName" />
    </GuiButton>
  </div>
</template>

<script>
import { Icon, GuiButton, useLocalization } from "@thegetty-private/getty-ui";

export default {
  name: "DownloadImageButton",
  components: { GuiButton, Icon },

  props: {
    /**
    Download image size to display on button */
    imageSize: {
      type: String,
      default: undefined
    },
    /**
     * Triggers what icon to display for the menu toggle */
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  emits: ["download"],
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {};
  },
  computed: {
    /**
     * Translated/formatted text for the button
     */
    buttonText() {
      return this.translatePart("object_page.download_image_button", {
        size: this.imageSize
      });
    },
    /**
     * Determines which icon should be displayed (expandMore or expandLess)
     */
    iconName() {
      return this.showMenu ? "expandLess" : "expandMore";
    },
    /**
     * get the aria label for the toggle button
     */
    toggleAriaLabel() {
      if (this.showMenu) {
        return this.translatePart("object_page.hide_menu");
      }
      return this.translatePart("object_page.show_menu");
    }
  },
  methods: {
    /**
     * Initiates a download for the image
     * @emits {download}
     */
    initateDownload() {
      this.$emit("download", this.imageSize);
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
